import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, CheckCircle2 } from "lucide-react";
import { api, errMsg } from "../lib/api";

const Field = ({ label, k, f, set, required, testid }) => (
  <label className="block">
    <span className="tl-label">{label}{required && " *"}</span>
    <input className="tl-input" required={required} value={f[k]} onChange={(e) => set({ ...f, [k]: e.target.value })} data-testid={testid} />
  </label>
);

export function RegisterForm({ reg }) {
  const [f, setF] = useState({ requested_role: "soustraitant", name: reg.name || "", phone: "", company_name: "", vat_number: "", address: "", employee_id: "", employer: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const sub = f.requested_role === "soustraitant";
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try { await api.post("/auth/register", { ...f, reg_token: reg.reg_token }); setDone(true); } catch (err) { setError(errMsg(err)); }
    setBusy(false);
  };
  if (done) {
    return (
      <div className="min-h-screen grid place-items-center p-6">
        <div className="tl-card max-w-md w-full text-center space-y-4" data-testid="register-done">
          <CheckCircle2 className="mx-auto text-emerald-600" size={36} />
          <p className="text-sm">Votre fiche est envoyée. Un administrateur ou un gestionnaire va l'examiner ; vous recevrez un e-mail à <b>{reg.email}</b> dès sa décision.</p>
          <Link to="/login" className="tl-btn tl-btn-primary w-full" data-testid="register-back">Retour à la connexion</Link>
        </div>
      </div>
    );
  }
  return (
    <div className="min-h-screen grid place-items-center p-4 sm:p-6">
      <form onSubmit={submit} className="tl-card max-w-lg w-full space-y-4" data-testid="register-form">
        <div>
          <h2 className="text-2xl font-bold uppercase">Fiche d'inscription</h2>
          <p className="text-sm text-slate-500 mt-1">Compte : <b data-testid="register-email">{reg.email}</b>. Votre accès sera ouvert après validation.</p>
        </div>
        <div className="grid grid-cols-2 gap-2" role="radiogroup">
          {[["soustraitant", "Sous-traitant"], ["chauffeur", "Chauffeur"]].map(([k, l]) => (
            <button type="button" key={k} onClick={() => setF({ ...f, requested_role: k })} className={`tl-btn ${f.requested_role === k ? "tl-btn-dark" : "tl-btn-ghost border border-slate-300"}`} data-testid={`register-role-${k}`}>{l}</button>
          ))}
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          <Field label="Nom complet" k="name" f={f} set={setF} required testid="register-name" />
          <Field label="Téléphone" k="phone" f={f} set={setF} required testid="register-phone" />
          {sub ? (
            <>
              <Field label="Nom de la société" k="company_name" f={f} set={setF} required testid="register-company" />
              <Field label="N° TVA" k="vat_number" f={f} set={setF} required testid="register-vat" />
              <div className="sm:col-span-2"><Field label="Adresse" k="address" f={f} set={setF} testid="register-address" /></div>
            </>
          ) : (
            <>
              <Field label="ID chauffeur" k="employee_id" f={f} set={setF} required testid="register-employee-id" />
              <Field label="Société employeur" k="employer" f={f} set={setF} required testid="register-employer" />
            </>
          )}
        </div>
        <label className="block">
          <span className="tl-label">Message (facultatif)</span>
          <textarea className="tl-input" rows={2} value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} data-testid="register-message" />
        </label>
        {error && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg p-3" data-testid="register-error">{error}</div>}
        <button className="tl-btn tl-btn-primary w-full" disabled={busy} data-testid="register-submit">{busy && <Loader2 className="animate-spin" size={16} />} Envoyer ma demande</button>
      </form>
    </div>
  );
}
